/*
  App carousel.

  One slide visible at a time; the others sit parked left and right at opacity 0.
  Circular, so the arrows never disable — going back from the first lands on the
  last.

  What the markup already does, so this does not have to: every slide ships with
  its parked offset written into its inline style. If this file fails to load,
  slide one is visible and the rest are offstage, rather than seven slides
  stacked on centre at opacity 0.
*/
(function () {
  var OFFSET = 480;

  function Carousel(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-slide]'));
    this.captions = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-caption]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-dot]'));
    this.count = this.slides.length;
    this.index = 0;

    if (this.count === 0) return;

    this.bind();
    this.apply(0);
  }

  Carousel.prototype.bind = function () {
    var self = this;

    var prev = this.root.querySelector('[data-carousel-prev]');
    var next = this.root.querySelector('[data-carousel-next]');

    if (prev) prev.addEventListener('click', function () { self.step(-1); });
    if (next) next.addEventListener('click', function () { self.step(1); });

    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { self.apply(i); });
    });

    // Arrow keys move the carousel whenever focus is anywhere inside it. Without
    // this the dots are reachable by Tab but a keyboard user has to tab through
    // all seven to reach the last screen.
    this.root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        self.step(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        self.step(1);
      }
    });

    this.bindSwipe();
  };

  Carousel.prototype.bindSwipe = function () {
    var self = this;
    var startX = null;
    var startY = null;

    var stage = this.root.querySelector('.miles-carousel__stage') || this.root;

    stage.addEventListener(
      'touchstart',
      function (event) {
        if (event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      },
      { passive: true }
    );

    stage.addEventListener(
      'touchend',
      function (event) {
        if (startX === null) return;

        var touch = event.changedTouches[0];
        var dx = touch.clientX - startX;
        var dy = touch.clientY - startY;

        startX = null;
        startY = null;

        // Only act on a mostly-horizontal swipe past a threshold. Comparing
        // against the vertical delta is what stops a scroll down the page from
        // flicking the carousel sideways on the way.
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;

        self.step(dx < 0 ? 1 : -1);
      },
      { passive: true }
    );
  };

  Carousel.prototype.step = function (delta) {
    this.apply(this.index + delta);
  };

  Carousel.prototype.apply = function (target) {
    var n = this.count;
    // Normalise into range the long way round, because JS % keeps the sign of
    // the dividend: -1 % 7 is -1, not 6.
    var active = ((target % n) + n) % n;
    this.index = active;

    this.slides.forEach(function (slide, i) {
      var off = i - active;
      if (off > n / 2) off -= n;
      if (off < -n / 2) off += n;

      var isActive = off === 0;

      slide.style.transform = 'translateX(calc(-50% + ' + off * OFFSET + 'px))';
      slide.style.opacity = isActive ? '1' : '0';
      slide.style.zIndex = isActive ? '10' : '1';
      slide.style.pointerEvents = isActive ? 'auto' : 'none';

      // Parked slides are invisible but still in the DOM, so they have to leave
      // the accessibility tree too — otherwise a screen reader reads all seven.
      if (isActive) {
        slide.removeAttribute('aria-hidden');
      } else {
        slide.setAttribute('aria-hidden', 'true');
      }
    });

    this.captions.forEach(function (caption, i) {
      caption.style.opacity = i === active ? '1' : '0';
    });

    this.dots.forEach(function (dot, i) {
      dot.setAttribute('aria-current', i === active ? 'true' : 'false');
    });
  };

  function init() {
    var roots = document.querySelectorAll('miles-carousel');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.milesCarouselReady === 'true') return;
      root.dataset.milesCarouselReady = 'true';
      new Carousel(root);
    });
  }

  init();

  // The theme editor re-renders a section into the DOM without a page load, so
  // a section added or moved in the editor would otherwise arrive uninitialised.
  document.addEventListener('shopify:section:load', init);
})();
